import _typeof from "@babel/runtime/helpers/esm/typeof";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _setPrototypeOf from "@babel/runtime/helpers/esm/setPrototypeOf";
function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(e, r) { return new BabelRegExp(e, void 0, r); }; var e = RegExp.prototype, r = new WeakMap(); function BabelRegExp(e, t, p) { var o = RegExp(e, t); return r.set(o, p || r.get(e)), _setPrototypeOf(o, BabelRegExp.prototype); } function buildGroups(e, t) { var p = r.get(t); return Object.keys(p).reduce(function (r, t) { var o = p[t]; if ("number" == typeof o) r[t] = e[o];else { for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) i++; r[t] = e[o[i]]; } return r; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (r) { var t = e.exec.call(this, r); if (t) { t.groups = buildGroups(t, this); var p = t.indices; p && (p.groups = buildGroups(p, this)); } return t; }, BabelRegExp.prototype[Symbol.replace] = function (t, p) { if ("string" == typeof p) { var o = r.get(this); return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)>/g, function (e, r) { var t = o[r]; return "$" + (Array.isArray(t) ? t.join("$") : t); })); } if ("function" == typeof p) { var i = this; return e[Symbol.replace].call(this, t, function () { var e = arguments; return "object" != _typeof(e[e.length - 1]) && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e); }); } return e[Symbol.replace].call(this, t, p); }, _wrapRegExp.apply(this, arguments); }
import "core-js/modules/es.symbol.replace.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/esnext.weak-map.delete-all.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import Report from '~/components/comments/Report.vue';
import Form from '~/components/comments/Form.vue';
import CasesDropdown from "~/components/CasesDropdown.vue";
import DdButton from '~/components/DdButton.vue';
import entities from 'entities';
import Dial from '~/components/Dial.vue';
import WebpPicture from '~/components/WebpPicture.vue';
import Like from '~/components/reactions/Like.vue';
export default {
  name: 'Comment',
  components: {
    Report: Report,
    Form: Form,
    CasesDropdown: CasesDropdown,
    DdButton: DdButton,
    Like: Like,
    Dial: Dial,
    WebpPicture: WebpPicture
  },
  props: ['rawComment', 'user', 'modelName', 'modelId', 'newCase', 'drafts'],
  data: function data() {
    return {
      shortText: null,
      reply: null,
      replyType: null,
      editing: false,
      deleting: false,
      deleteCountdown: 5,
      liked: false
    };
  },
  computed: {
    comment: function comment() {
      if (this.rawComment.childs && this.rawComment.childs.length) {
        this.rawComment.childs.sort(function (a, b) {
          return a.createdTime - b.createdTime;
        });
      }
      this.rawComment.date = new Date(this.rawComment.date);
      return this.rawComment;
    },
    now: function now() {
      return useTimeStore().now;
    },
    editedAt: function editedAt() {
      var date = this.comment.editedAt || null;
      if (date && typeof date == 'string') {
        date = new Date(date);
      }
      return date;
    },
    ago: function ago() {
      return this.$timeformat.ago(this.comment.date, this.now);
    },
    formatedComment: function formatedComment() {
      if (!this.comment.text) return this.comment.text;

      // Remove all tags from description
      var text = this.comment.text.replace(/<(?:.|\n)*?>/gm, '');

      // Finding links and pasting them to description as html tag
      text = this.urlify(text);

      // Decode HTML
      return entities.decodeHTML(text);
    },
    formatedShortText: function formatedShortText() {
      if (!this.shortText) return this.shortText;

      // Remove all tags from description
      var text = this.shortText.replace(/<(?:.|\n)*?>/gm, '');

      // Finding links and pasting them to description as html tag
      text = this.urlify(text);

      // Decode HTML
      return entities.decodeHTML(text);
    },
    child: function child() {
      return this.comment.parent ? true : false;
    },
    ownComment: function ownComment() {
      return this.user.id == this.comment.user.id;
    },
    canCreate: function canCreate() {
      return this.user && this.user.canCreate;
    },
    usersListStore: function usersListStore() {
      return useUsersListStore();
    },
    appStore: function appStore() {
      return useAppStore();
    },
    draft: function draft() {
      var _this = this;
      return this.drafts.find(function (o) {
        return o.parent == _this.rawComment.id;
      });
    }
  },
  // Lifecycle Events
  beforeMount: function beforeMount() {
    if (this.comment.text.length > 350) {
      this.shortText = this.comment.text.slice(0, 350);
    }
    this.liked = !!this.rawComment.liked;
  },
  methods: {
    showLikes: function showLikes(id) {
      this.usersListStore.update({
        id: "comment-likes-".concat(id),
        url: '/user/getlikes',
        title: 'likes',
        params: {
          model: 'comment',
          id: id
        }
      });
    },
    loadComments: function loadComments(id) {
      var _this2 = this;
      var clear = function clear() {
        return _this2.comment.hiddenChilds = 0;
      };
      this.$emit('loadComments', {
        parent: id,
        cb: clear
      });
    },
    urlify: function urlify(str) {
      var _this3 = this;
      var urlRegex = /(https?:\/\/[^\s]+)/g;
      return str.replace(urlRegex, function (url) {
        return '<a class="b-link" target="_blank" rel="noopener ugc nofollow" href="' + url + '">' + _this3.formatUrl(url) + '</a>';
      });
    },
    formatUrl: function formatUrl(url) {
      // Split the URL into an array to distinguish double slashes from single slashes
      var doubleSlash = url.split('//');

      // Format the strings on either side of double slashes separately
      var formatted = doubleSlash.map(function (str) {
        return (
          // Insert a word break opportunity after a colon
          str.replace(/*#__PURE__*/_wrapRegExp(/(:)/gi, {
            after: 1
          }), '$1<wbr>')
          // Before a single slash, tilde, period, comma, hyphen, underline, question mark, number sign, or percent symbol
          .replace(/*#__PURE__*/_wrapRegExp(/([#%,-\/\?@_~])/gi, {
            before: 1
          }), '<wbr>$1')
          // Before and after an equals sign or ampersand
          .replace(/*#__PURE__*/_wrapRegExp(/([&=])/gi, {
            beforeAndAfter: 1
          }), '<wbr>$1<wbr>')
        );
      }
      // Reconnect the strings with word break opportunities after double slashes
      ).join('//<wbr>');
      return formatted;
    },
    replyTo: function replyTo(id, type) {
      var _this4 = this;
      // Child comment cant have own thread
      // delegate this action to it's parent
      this.$modalityStore.closeDropdown({
        name: "comment-actions-".concat(this.comment.id)
      });
      if (this.comment.parent) return this.$parent.replyTo(id, type);
      this.reply = id;
      this.replyType = type;

      // this.bus.$emit('focusForm');
      this.$nextTick(function () {
        _this4.$refs.form.setFocus();
      });
    },
    block: function block() {
      var _this5 = this;
      this.$modalityStore.closeDropdown({
        name: "comment-actions-".concat(this.comment.id)
      });
      var action = this.comment.blocked ? 'unblock' : 'block';
      var url = '/comment/' + action;
      var params = {
        _csrf: this.appStore.csrfToken,
        id: this.comment.id
      };
      if (confirm('Confirm') == true) {
        this.$socket.post(url, params, function (resData, jwres) {
          if (jwres.statusCode !== 200) {
            alert('Error occured! Watch details in console');
            return console.error(resData);
          }
          _this5.comment.blocked = !_this5.comment.blocked;
        });
      }
    },
    show: function show() {
      var _this6 = this;
      this.$modalityStore.closeDropdown({
        name: "comment-actions-".concat(this.comment.id)
      });
      this.$socket.post('/comment/show', {
        _csrf: this.appStore.csrfToken,
        id: this.comment.id
      }, function (resData, jwres) {
        if (jwres.statusCode !== 200) {
          alert('Error occured! Watch details in console');
          return console.error(resData);
        }
        _this6.comment.hidden = false;
      });
    },
    cancelDeleting: function cancelDeleting() {
      this.deleting = false;
      if (this.timer) clearInterval(this.timer);
    },
    remove: function remove() {
      var _this7 = this;
      this.$modalityStore.closeDropdown({
        name: "comment-actions-".concat(this.comment.id)
      });
      this.deleting = true;
      this.timer = setInterval(function () {
        if (_this7.deleteCountdown == 1) {
          clearInterval(_this7.timer);
          _this7.$socket.post('/comment/destroy', {
            _csrf: _this7.appStore.csrfToken,
            id: _this7.comment.id
          }, function (resData, jwres) {
            if (jwres.statusCode !== 200) {
              _this7.deleting = false;
              alert('Error occured! Watch details in console');
              return console.error(resData);
            }
            _this7.deleteComment(_this7.comment);
          });
        } else {
          _this7.deleteCountdown--;
        }
      }, 1000);
    },
    edit: function edit() {
      this.$modalityStore.closeDropdown({
        name: "comment-actions-".concat(this.comment.id)
      });
      this.editing = true;
    },
    updateComment: function updateComment(text) {
      this.editing = false;
      this.comment.text = text;
      this.comment.editedAt = new Date();
    },
    openGallery: function openGallery(index) {
      this.$emit('openGallery', {
        gallery: this.comment.images,
        index: index
      });
    },
    // Bubble 🆙
    placeComments: function placeComments(data) {
      this.$emit('placeComments', data);
    },
    increaseLength: function increaseLength(data) {
      this.$emit('increaseLength', data);
    },
    placeReports: function placeReports(data) {
      this.$emit('placeReports', data);
    },
    loadCommentsEmiter: function loadCommentsEmiter(data) {
      this.$emit('loadComments', data);
    },
    openGalleryEmiter: function openGalleryEmiter(data) {
      this.$emit('openGallery', data);
    },
    deleteComment: function deleteComment(data) {
      this.$emit('deleteComment', data);
    }
  }
};